import { Button, Stack } from '@forwardflow/ui-v2'
import { IFilterCriteria } from '../interfaces'
import { PRIMARY_FILTER_OPTIONS } from '../constants'
import { FilterRow } from './FilterRow'

interface FilterEditorProps {
   filters: IFilterCriteria[]
   onChange: (filters: IFilterCriteria[]) => void
}

export const FilterEditor = ({ filters, onChange }: FilterEditorProps) => {
   const getUsedFields = () => {
      const usedFields = new Set<string>()
      filters.forEach((criteria) => {
         if (criteria.field) {
            usedFields.add(criteria.field)
         }
      })
      return usedFields
   }

   const getAvailableFields = () => {
      const usedFields = getUsedFields()
      return PRIMARY_FILTER_OPTIONS.filter(
         (option) => !usedFields.has(option.value)
      )
   }

   const handleAddFilter = () => {
      const availableFields = getAvailableFields()
      if (availableFields.length === 0) return

      const newFilter: IFilterCriteria = {
         field: availableFields[0].value as IFilterCriteria['field'],
         value: [],
         logic: 'AND',
         operator: 'CONTAINS_ANY',
      }
      onChange([...filters, newFilter])
   }

   const handleRemoveFilter = (index: number) => {
      onChange(filters.filter((_, i) => i !== index))
   }

   const handleUpdateFilter = (index: number, filter: IFilterCriteria) => {
      const updatedFilters = [...filters]
      updatedFilters[index] = filter
      onChange(updatedFilters)
   }

   return (
      <Stack gap={16}>
         {filters.map((filterCriteria, index) => (
            <FilterRow
               key={`${filterCriteria.field}-${index}`}
               filterCriteria={filterCriteria}
               onUpdate={(filter) => handleUpdateFilter(index, filter)}
               onRemove={() => handleRemoveFilter(index)}
               usedFields={getUsedFields()}
            />
         ))}
         <Button
            variant="secondary"
            className="w-full"
            onClick={handleAddFilter}
            disabled={getAvailableFields().length === 0}
         >
            Add Filter
         </Button>
      </Stack>
   )
}
